// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"99641a4d","547":"357e433c","5794":"357e433c","6260":"edda148a","7693":"99641a4d","9492":"99641a4d"}[chunkId] + ".chunk.css";
};